import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import PortalSwitcher from "@/components/PortalSwitcher";
import CrashReadyVoice from "@/components/CrashReadyVoice";
import { Scale, LogOut, Inbox, Plug2, Code2, Sparkles, Building2, Radar } from "lucide-react";

const NAV = [
  { to: "/attorney", label: "Referrals", icon: Inbox },
  { to: "/command-center", label: "Command", icon: Radar },
  { to: "/intelligence", label: "Intelligence", icon: Sparkles },
  { to: "/integrations", label: "Integrations", icon: Plug2 },
  { to: "/developer", label: "Developer", icon: Code2 },
  { to: "/firm", label: "Firm", icon: Building2 },
];

export default function AttorneyShell({ children }) {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const doLogout = async () => { await logout(); navigate("/"); };

  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-50 backdrop-blur-xl bg-white/80 border-b border-slate-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between gap-4">
          <div className="flex items-center gap-4 min-w-0 flex-1">
            <Link to="/attorney" className="flex items-center gap-2 shrink-0">
              <div className="h-8 w-8 rounded-xl bg-navy flex items-center justify-center"><Scale className="w-5 h-5 text-white" strokeWidth={2.2} /></div>
              <span className="font-heading font-extrabold text-lg tracking-tight text-navy whitespace-nowrap hidden sm:inline">Crash Ready <span className="text-cobalt">Attorney</span></span>
            </Link>
            <nav className="hidden md:flex items-center gap-1 min-w-0 overflow-x-auto" style={{ scrollbarWidth: "none" }}>
              {NAV.map((n) => {
                const active = pathname === n.to;
                return (
                  <Link key={n.to} to={n.to} data-testid={`nav-${n.label.toLowerCase()}`}
                    className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm font-medium transition-all shrink-0 whitespace-nowrap ${active ? "bg-cobalt-light text-cobalt" : "text-slate-600 hover:bg-slate-100"}`}>
                    <n.icon className="w-4 h-4" /> {n.label}
                  </Link>
                );
              })}
            </nav>
          </div>
          <div className="flex items-center gap-2 shrink-0">
            <PortalSwitcher />
            <button onClick={doLogout} data-testid="attorney-logout" className="flex items-center gap-2 px-3 lg:px-4 py-2 rounded-full text-sm font-medium text-slate-600 hover:bg-red-50 hover:text-red-600 transition-all"><LogOut className="w-4 h-4" /> <span className="hidden lg:inline">Logout</span></button>
          </div>
        </div>
      </header>
      <main className="max-w-7xl mx-auto px-4 sm:px-6 py-8">{children}</main>
      <CrashReadyVoice />
    </div>
  );
}
